import { StorageData } from '~Components/Storage';
import { getLogger } from '~Hooks';

import { PersistedOrderSync } from './types';

const logger = getLogger('persisted-order-sync');

/**
 * Always on for Handy. The app uses a HashRouter, so the route lives in the hash
 * (`#/venue/<id>/handy`).
 */
export function shouldPersistOrderForSync(): boolean {
  return window.location.hash.includes('/handy');
}

/**
 * Writes a paid order to device storage instead of dispatching SYNC_POS_ORDER.
 * `PersistedOrderSyncReplayer` dispatches it into the existing flow and removes it once
 * that flow has synced it.
 */
export function persistOrderForSync(
  current: StorageData,
  updateStorage: (data: Partial<StorageData>) => void,
  data: PersistedOrderSync,
): void {
  const others = current.pendingOrderSyncs.filter((p) => p.order.id !== data.order.id);

  updateStorage({ pendingOrderSyncs: [...others, data] });

  logger.info(`Persisted order ${data.order.id} for sync`, {
    orderId: data.order.id,
    amount: data.amount,
    method: data.payment.method,
    transactionId: data.payment.meta?.transactionId,
  });
}
